import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SearchAccountMasterComponent } from './search-account-master/search-account-master.component';
import { BranchMatserService } from 'app/masters/branch-matser.service';
import { AccountHeadMasterModel, AccountMasterModel, AccountTypeMasterModel } from 'app/masters/models/account-master.model';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { AuthService } from 'app/auth/auth.service';

@Component({
  selector: 'app-account-master',
  templateUrl: './account-master.component.html',
  styleUrls: ['./account-master.component.scss']
})
export class AccountMasterComponent implements OnInit {
  accountdestroy$: Subject<boolean> = new Subject<boolean>();
  AccountMasterModeldata: AccountMasterModel[] = [];
  AccountHeadMasterModeldata: AccountHeadMasterModel[] = [];
  AccountTypeMasterModeldata: AccountTypeMasterModel[] = [];
  accountmasterobject: AccountMasterModel = {};
  HeadMasterControl = new FormControl('');
  filteredHeadMaster: Observable<any[]>;
  TypeMasterControl = new FormControl('');
  filteredTypeMaster: Observable<any[]>;
  enableBtn:boolean = true;
  constructor(private authService: AuthService, public dialog: MatDialog, public branchMatserService: BranchMatserService, public dashboardservice: DashboardService) { }

  ngOnInit(): void {
    // this.getAccountMaster(this.authService.Loggeduser.branchid);
    this.getAccountMaster(0);
    this.GetAccountHeadMaster(0);
    this.GetAccountTypeMaster(0);
    this.Cleardata();
  }
  GetAccountTypeMaster(parameter) {
    this.branchMatserService.GetAccountTypeMaster(parameter).pipe(takeUntil(this.accountdestroy$)).subscribe((x: any) => {
      this.AccountTypeMasterModeldata = [];
      this.AccountTypeMasterModeldata = x.filter(item => item.isActive == true);
      this.AccountfromControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  AccountfromControl() {
    this.filteredTypeMaster = this.TypeMasterControl.valueChanges.pipe(
      startWith(''),
      map(cat => this.AccountTypeMasterModeldata.slice())
    );
  }
  getAccountTypeobj(e: any) {
    var val = e.option.value;
    this.accountmasterobject.accountType = val.accountType;
    this.accountmasterobject.fK_AccountTypeId = val.pK_AccountTypeId;
  }
  CheckTypeName(event) {
    if (event.target.value == "") {
      this.accountmasterobject.fK_AccountTypeId = 0;

    }
  }
  GetAccountHeadMaster(parameter) {
    this.branchMatserService.GetAccountHeadMaster(parameter).pipe(takeUntil(this.accountdestroy$)).subscribe((x: any) => {
      this.AccountHeadMasterModeldata = [];
      this.AccountHeadMasterModeldata = x;
      this.headfromControl();
    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  headfromControl() {
    this.filteredHeadMaster = this.HeadMasterControl.valueChanges.pipe(
      startWith(''),
      map(cat => this.AccountHeadMasterModeldata.filter(item => item.isActive == true).slice())
    );
  }
  getHeadNameTypeobj(e: any) {

    var val = e.option.value;
    this.accountmasterobject.accountHeadName = val.accountHeadName;
    this.accountmasterobject.fK_AccountHeadId = val.pK_AccountHeadId;
  }
  CheckHeadName(event) {
    if (event.target.value == "") {
      this.accountmasterobject.fK_AccountHeadId = 0;

    }
  }
  getAccountMaster(parameter: any) {
    this.branchMatserService.GetAccountMaster(parameter).pipe(takeUntil(this.accountdestroy$)).subscribe((x: any) => {
      this.AccountMasterModeldata = [];
      this.AccountMasterModeldata = x;
    }, err => {
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }
    });
  }
  /** Search Account Master */
  searchAccountMaster() {
    const dialogRef = this.dialog.open(SearchAccountMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "55%",
      width: "50%",
      disableClose: true,
      data: this.AccountMasterModeldata
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined && result != 0) {
        this.accountmasterobject = {};
        this.accountmasterobject = JSON.parse(JSON.stringify(result));
        this.accountmasterobject.isEdit = true;
      }
    });
  }
  saveAccountMaster(event) {
    if (!this.accountmasterobject.accountCode) {
      this.dashboardservice.openSnackBar("Please Select Account Code", "OK")
      return;
    }

    if (!this.accountmasterobject.accountName) {
      this.dashboardservice.openSnackBar("Please Select Account Name", "OK")
      return;
    }

    if (!this.accountmasterobject.accountHeadName || !this.accountmasterobject.accountHeadName.trim()) {
      this.dashboardservice.openSnackBar("Please Select Head Type", "OK");
      return;
    }

    const isValidHeadType = this.AccountHeadMasterModeldata.some(head => head.accountHeadName == this.accountmasterobject.accountHeadName);
  if (!this.accountmasterobject.fK_AccountHeadId || !isValidHeadType) {
    this.dashboardservice.openSnackBar("Please Select a Valid Head Type", "OK");
    return;
  }

  if (!this.accountmasterobject.accountType || !this.accountmasterobject.accountType.trim()) {
    this.dashboardservice.openSnackBar("Please Select Account Type", "OK");
    return;
  }

  const isValidAccountType = this.AccountTypeMasterModeldata.some(head => head.accountType == this.accountmasterobject.accountType);
  if (!this.accountmasterobject.fK_AccountTypeId || !isValidAccountType) {
    this.dashboardservice.openSnackBar("Please Select a Valid Account Type", "OK");
    return;
  }

    const accounttypeInput = this.accountmasterobject.accountType?.trim();
    const accountheadInput =  this.accountmasterobject.accountHeadName?.trim();
    const accountName = this.accountmasterobject.accountName?.trim();
    if ( !this.accountmasterobject.pK_AccountId && accounttypeInput && accountheadInput && accountName) {
        const isInputValid = this.AccountMasterModeldata.some(item => 
          item.accountType?.toLowerCase() === accounttypeInput.toLowerCase() && 
          item.accountName?.toLowerCase() === accountName.toLowerCase() &&
          item.accountHeadName?.toLowerCase() === accountheadInput.toLowerCase() 
      );
        if (isInputValid) {
            this.dashboardservice.openSnackBar("Record Already Exists","OK");
            return;
        }
    }
     const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);

    let payload = {
      "AccountMaster": this.accountmasterobject
    }
    this.branchMatserService.InsertAccountMaster(payload).pipe(takeUntil(this.accountdestroy$)).subscribe((x: any) => {
      this.getAccountMaster(0);
      if (this.accountmasterobject.pK_AccountId > 0) {
        this.dashboardservice.openSnackBar("Record Updated Successfully", "ok");
      } else {
        this.dashboardservice.openSnackBar("Record Saved Successfully", "ok");
      }
      this.Cleardata();
    }, err => {
       button.removeAttribute('disabled');
      if (err.status == 403) {
        this.dashboardservice.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardservice.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardservice.openSnackBar("API Failed", "OK");
      }

    });
  }
  ngOnDestroy() {
    this.accountdestroy$.next(true);
    this.accountdestroy$.unsubscribe();
    this.AccountMasterModeldata = null;
    this.AccountHeadMasterModeldata = null;
    this.AccountTypeMasterModeldata = null;
  }

  Cleardata() {
    this.accountmasterobject = {};
    this.accountmasterobject.pK_AccountId = 0;
    this.accountmasterobject.isEdit = false
    this.accountmasterobject.isActive = false
  }
}
